import React from 'react';
import TextInfo from '@gerenciatd/next.components.text-info-n'
import Icon from '@gerenciatd/next.components.icon-n';
import CustomLink from '@gerenciatd/next.components.custom-link'

const ProductCard = (props) => {
  const { id, courtainColor, custoObjectInfo, selected, onClick } = props;
  const selectedCss = selected ? ' selected' : ' no-selected';
  let textInfoCustoObjectInfo1 = null;
  let iconCustoObjectInfo = null;
  if (custoObjectInfo){
    textInfoCustoObjectInfo1 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'TextInfo-1',
    })
    iconCustoObjectInfo = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'Icon-1',
    })
  }

  return (
    <>
      <div className="ProductCard">
        <div className={`courtain ${courtainColor}${selectedCss}`} />
        <div className={`SubjectElement ${selectedCss}`}>
          {props['TextInfo-1'] && (
            <TextInfo {...props['TextInfo-1']} custoObjectInfo={textInfoCustoObjectInfo1} />
          )}
          {props['Icon-1'] && (
            <Icon {...props['Icon-1']} custoObjectInfo={iconCustoObjectInfo} />
          )}
          </div>
          {!textInfoCustoObjectInfo1 && (
            <CustomLink onClick={() => onClick(id)} taggingInfo={{
              componentName:'configuradortv',
              componentContent: (props['TextInfo-1'] &&  props['TextInfo-1'].text) || `Product-${id}`,
              componentVariation: 'all',
              componentProduct: ''
            }} />
          )}
      </div>
      <style jsx>
        {`
          .ProductCard {
            position: relative;
            width: 30%;
            height: 10.60rem;
            margin: 1rem;
            min-width: 22.5rem;
            background-color:white;
            box-shadow: 0 3px 6px rgb(0 0 0 / 10%);
            .courtain {
              position: absolute;
              top:0px;
              left: 0px;
              width: 100%;
              height: 1rem;
              transition: all 0.3s;
              &.red {
                background-color: #ec624b;
              }
              &.purple {
                background-color: #a13ea1;
              }
              &.green {
                background-color: #5cb615
              }
              &.selected {
                height:100%;
              }        
            }

            .SubjectElement {
              position: absolute;
              display:flex;
              justify-content: space-between;
              left: 0px;
              bottom: 0px;
              padding: 1rem;
              width: 100%;
              transition: all 0.3s;
              &.selected {
                :global(span){
                  color: white !important;
                  transition: all 0.3s;
                }
                :global(span::before){
                  color: white !important;
                  transition: all 0.3s;
                }
              }
            }

          }
          @media screen and (max-width:1260px){
            .ProductCard{
              min-width: 20rem;
            }
          }
          @media screen and (max-width: 500px) {
            .ProductCard {
              min-width: 300px;
            }
          }
        `}
      </style>
    </>
  )
}

export default ProductCard;